import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Collapse, List } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';
import Image from '../../../common/image';

const ADMProduct = ({ data, className, docsOnly = false }) => {
	if (!isValidArray(data?.document_groups?.group)) return null;

	return (
		<div
			className={`adm-product border border-neutral-100 odd:bg-white even:bg-neutral-25 ${className || ''}`}
			data-testid='adm-product'
		>
			<Collapse
				className='!border-0'
				isOpen={docsOnly}
			>
				{!docsOnly && <Collapse.Trigger className='text-subtitle !m-0 !px-4 font-semibold'>{data?.display_name}</Collapse.Trigger>}
				<Collapse.Content className='!px-4 !pt-0'>
					<div className={`grid grid-cols-[auto_1fr] items-start ${!docsOnly && data?.cob?.url ? 'gap-x-6' : ''}`}>
						{!docsOnly && data?.cob?.url && (
							<div className='col-span-1 col-start-1 w-20 text-center md:w-28 xl:w-40'>
								<Image
									data={{ image: data.cob }}
									data-testid='adm-product-cob'
								/>
							</div>
						)}

						{isValidArray(data?.document_groups?.group) && (
							<div className='columns columns-1 md:columns-2 xl:columns-3'>
								{data.document_groups.group.map((group, index) => {
									if (!isValidArray(group.document_links)) return null;

									return (
										<div
											key={`col-${index}`}
											className='break-inside-avoid-column'
										>
											<p className='border-b border-b-neutral-200 py-4 font-semibold md:tracking-0.25px'>{group.group_heading}</p>

											<List
												bullets='none'
												className='space-y-4 py-4'
											>
												{group.document_links.map((link, index) => (
													<li
														className='text-base'
														key={`doc-${index}`}
													>
														<a
															href={link.link.url}
															target='_blank'
															rel='noreferrer noopener nofollow'
															className='group flex items-start gap-x-3 decoration-transparent'
															title={link.ada_link_title}
															download
														>
															<Image
																data={{ image: link.icon?.url ? link.icon : { url: 'https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blt28842554c238f301/pdf.png' } }}
																className='mt-[3px] flex-none'
																data-testid={link.icon?.url ? 'adm-product-icon' : 'adm-pdf-icon'}
															/>

															<span className='max-w-max flex-1 leading-tight underline group-hover:no-underline'>{link.link.link_title}</span>

															{link.badge?.[0]?.badge && (
																<Badge
																	color={link.badge[0].color}
																	dangerouslySetInnerHTML={{ __html: link.badge[0].badge }}
																	className='flex-initial !border-0 !px-1 !pb-1'
																	size='md'
																/>
															)}
														</a>
													</li>
												))}
											</List>
										</div>
									);
								})}
							</div>
						)}
					</div>
				</Collapse.Content>
			</Collapse>
		</div>
	);
};

ADMProduct.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
	docsOnly: PropTypes.bool,
};

export default ADMProduct;
